import { api } from "@/lib/api";

// Native push registration via @capacitor-firebase/messaging.
// On web this is a graceful no-op so the PWA keeps working.
// On iOS/Android it requests permission, retrieves the FCM token (Firebase
// Messaging bridges the iOS APNs token → FCM token), and sends it to the backend
// so our firebase-admin backend can push to this device.
export async function initPush(onNotification) {
  try {
    const { Capacitor } = await import("@capacitor/core");
    if (!Capacitor?.isNativePlatform?.()) return false; // web build → skip

    const { FirebaseMessaging } = await import("@capacitor-firebase/messaging");

    let perm = await FirebaseMessaging.checkPermissions();
    if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
      perm = await FirebaseMessaging.requestPermissions();
    }
    if (perm.receive !== "granted") return false;

    const sendToken = async (value) => {
      if (!value) return;
      try {
        await api.post("/notifications/register-token", {
          token: value,
          platform: Capacitor.getPlatform(),
        });
      } catch (e) {
        /* token will be retried on next launch */
      }
    };

    // Get the current FCM token and register it with the backend.
    try {
      const { token } = await FirebaseMessaging.getToken();
      await sendToken(token);
    } catch (e) {
      console.warn("FCM getToken failed", e);
    }

    // Token can rotate — keep the backend in sync.
    await FirebaseMessaging.addListener("tokenReceived", (event) => {
      sendToken(event?.token);
    });
    await FirebaseMessaging.addListener("notificationReceived", () => {
      onNotification?.();
    });
    await FirebaseMessaging.addListener("notificationActionPerformed", () => {
      onNotification?.();
    });
    return true;
  } catch (e) {
    // plugin unavailable (e.g. web) — ignore
    return false;
  }
}
